import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationSoldDistributionCounter } from '@/api/bairun/financialCenter';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
export default {
  name: 'SlotCounterStationSoldDistributionSheet',
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      default: 0
    },
    sheetType: {
      type: String,
      required: true
    },
    slotCounterName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      switchValue: false,
      loading: false,
      slotOption: '',
      selectedOilCode: '999',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      groupData: [],
      renderData: [],
      borderFix: ['合计/L', '合/L', '0#'],
      cellColClassFix: ['monthSumUserNums', 'monthGoodsPrice', 'monthAvgUserPrice', 'monthDiffUserPrice', 'monthSumSvcNums', 'monthAvgSvcPrice', 'monthDiffSvcPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadMemberDiscountData();
    },
    selectedOilCode: function selectedOilCode() {
      this.loadMemberDiscountData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadMemberDiscountData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['tableStationSoldDistribution' + _this.sheetType].doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['tableStationSoldDistribution' + this.sheetType].doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    percentShow: function percentShow(a, b) {
      if (b === 0) return '0%';
      return NP.round(NP.times(NP.divide(Number(a), Number(b)), 100), 2) + '%';
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['stationId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    percentFormat: function percentFormat(value1, value2) {
      return value2 === 0 ? '--' : NP.round(NP.divide(value1, value2) * 100, 2) + '%';
    },
    numsFormat: function numsFormat(value) {
      return NP.round(NP.divide(value, 10000), 2);
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];

      var _that = this;

      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (column.property === 'totalA') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data0'], item['data1'], item['data2'], item['data3'], item['data4'], item['data5'], item['data6'], item['data7']));
          });
        } else if (column.property === 'totalB') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data8'], item['data9'], item['data10'], item['data11'], item['data12'], item['data13'], item['data14'], item['data15']));
          });
        } else if (column.property === 'totalC') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data16'], item['data17'], item['data18'], item['data19'], item['data20'], item['data21'], item['data22'], item['data23']));
          });
        } else if (column.property === 'total') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data0'], item['data1'], item['data2'], item['data3'], item['data4'], item['data5'], item['data6'], item['data7'], item['data8'], item['data9'], item['data10'], item['data11'], item['data12'], item['data13'], item['data14'], item['data15'], item['data16'], item['data17'], item['data18'], item['data19'], item['data20'], item['data21'], item['data22'], item['data23']));
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadMemberDiscountData: function loadMemberDiscountData() {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: parseInt(this.selectedOilCode),
          name: this.slotCounterName,
          start: this.start / 1000,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getStationSoldDistributionCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this2.renderData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.stationId) - orders.indexOf(b.stationId);
        });
        _this2.loading = false;

        _this2.$refs['tableStationSoldDistribution' + _this2.sheetType].doLayout();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    getDistributionTypeData: function getDistributionTypeData(renderData, distributionType) {
      if (renderData.length === 0) {
        return [];
      }

      var arr = [];
      renderData.forEach(function (ele) {
        if (ele.distributionType === distributionType) {
          arr.push(ele);
        }
      });
      return arr;
    }
  }
};